const SHIP_API = {
  TOKEN: {
    INDEX: `api/token`,
    REFRESH: `api/token/refresh/`
  },
  SHIPS: {
    INDEX: `armour_ships/`
  }
}

export default SHIP_API
